import { useEffect, useState } from "react"
import { useFirestore } from "react-redux-firebase"

export default function useNotificationSettings({ customer, notify, auth }) {
  const firestore = useFirestore()
  const [values, setValues] = useState({
    all: false,
    order: false,
    promo: false,
    announcement: false,
  })
  const setValue = (key, value) => setValues({ ...values, [key]: value })
  useEffect(() => {
    if (customer) {
      setValues({
        ...values,
        all: customer?.notification?.all,
        order: customer?.notification?.order,
        announcement: customer?.notification?.announcement,
        promo: customer?.notification?.promo,
      })
    }
  }, [customer])
  const handleSubmit = async () => {
    try {
      await firestore
        .collection("customers")
        .doc(auth.uid)
        .update({ notification: values })
      const message = `Notification settings updated successfully.`
      notify("success", message, "Success")
    } catch (error) {
      const message =
        error?.message || `Error while updating notification settings.`
      console.log(error)
      notify("error", message, "Error")
    }
  }
  return {
    values,
    setValue,
    handleSubmit,
  }
}
